import APIService from './apiservice';
import cookie from 'js-cookie';
import { API_CLIENT_ID, API_CLIENT_SECRET } from '../constants';

const grant_type = 'password';
const user_info = 'userInfo';
const scope = '*';


class AuthService{
	
  async login(username, password) {
	  const data = await APIService.doPublicRequest(`oauth/token`, 'POST', {
              username,
              password,
              grant_type,
              scope,
              client_id: API_CLIENT_ID,
              client_secret: API_CLIENT_SECRET
          });
        
      if (data?.access_token) {
		    APIService.setToken(data.access_token);
        APIService.setTokenExpiresAt(data.expires_in);
      }
      
      return data;
  }

  async logout() {
	  try{
		  await APIService.doRequest(`api/v1/logout`, 'POST');
	  } catch (error){
		  
	  } finally {
		  APIService.handleLogout();
	  }
  }
  
  async getCurrentUser(){
	  let userInfo = APIService.getUserInfo();
	  const withAccessToken = APIService.getToken() ? true : false;
    if(userInfo === null && withAccessToken){
		  userInfo = await APIService.doRequest(`api/v1/auth-user-details`, 'GET');
		  APIService.setUserInfo(userInfo);
	  }
	  return userInfo;
  }

  async getCurrentUserReload(){
    let userInfo = APIService.getUserInfo();
	  const withAccessToken = APIService.getToken() ? true : false;
    if(withAccessToken){
		  userInfo = await APIService.doRequest(`api/v1/auth-user-details`, 'GET');
		  APIService.setUserInfo(userInfo);
	  }
	  return userInfo;
  }
  
  async getCurrentUserModules(){
	  const withAccessToken = APIService.getToken() ? true : false;
	  if(withAccessToken){
		  return await APIService.doRequest(`api/v1/auth-user-modules`, 'GET');		  
	  }
	  return [];
  }
  
  withAccessToken() {
	  return APIService.getToken() ? true : false;
  }

  getAccessToken() {
	  return APIService.getToken();
  }

  getUserInfo(){
    const userInfo = cookie.get(user_info);
    if(userInfo){
      return JSON.parse(userInfo);
    }
    return null;
  }
}

const authService = new AuthService();

export default authService;